import React, { Component } from "react";
import styled from "styled-components";
import { Flex, Link, Button } from "../../components";
import { history } from "../../utils";
import ProgressBar from "../../components/ProgressBar";
import vars from "../../vars";
import Hexagon2 from "../../components/Hexagon2";
import Modal from "./Modal";
import Modal1 from "./Modal1";
import InstructionModal from "./InstructionModal";
import MobileCarousel from '../../components/MobileCarousel/MobileCarousel';
import moment from 'moment';
import 'katex/dist/katex.min.css';
import MCQLayoutWrapper from '../../components/MCQLayoutWrapper';
import MCQuestion from "../../components/MCQuestion";
import Equation from '../../components/Equation';
import TestEquation from '../../components/TestEquation';
import { swipedetect } from '../../lib/swiper';
import Report from '../../components/Report/Report';
import {submitMCQQuestion, updateSeenStatus } from '../../lib/api';
import Shimmer from '../../components/shimmer';
import { track } from '@amplitude/analytics-browser';

const Box = styled.div`
  margin: 0 0 0.5em 0;
  padding-top: 0.2em;
  font-weight: bold;
  border-radius: 4px;
  background:white;
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
`;

const Image = styled(Flex)`
  height: 15rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Hint = styled(Flex)`
  padding: 0.3em 0;
  span{
    color: #4E54C8;
    font-size: 14px;
    // font-weight: bold;
  },
  svg {
    color: ${vars.brand_color};
    padding: 0.5em 0;
  }
`;

const QuestionOverviewWrapper = styled.div`
  display:initial;
  @media (max-width: 767px) {
    display: none;
  }
`
const ActionButtons = styled.div`
  @media(max-width:767px){
    display:none;
  }
`

const GridLayout = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 2rem;
  @media (max-width: 768px) {
    grid-template-columns: auto;
  }
`;

const Hex = () => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 300 300">
    <polygon points="300,150 225,280 75,280 0,150 75,20 225,20" />
  </svg>
);

const Hexagon = styled(Flex)`
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 3em;
    height: 3em;
    cursor: pointer;
    text-decoration: none;
    span {
      color: #000;
      z-index: 1;
    }
  }

  svg {
    position: absolute;
    fill: ${({ blue, yellow }) =>
    yellow ? "#eed94a" : blue ? "#42A5F5" : "#ccc"};
    width: 100%;
    height: 100%;
    polygon {
      stroke: ${({ active }) => (active ? vars.brand_color : "transparent")};
      stroke-width: 10px;
      transition: all 0.3s esae;
    }
    transition: all 0.3s esae;
  }
`;

  // blue ? "#42A5F5" : yellow ? "#eed94a" : "#ccc"};

const QuestionsOverview = styled.div`
  display: grid;
  grid-template-columns: repeat(4, auto);
  grid-gap: 1em;
`;

class TestStart extends Component {
  state = {
    modalOpen: false,
    testSubmittedModalOpen: false,
    windowChangeWarningModalOpen: false,
    questionnaire_id: this.props.tid,
    question_answers: this.props.questions.map(({ id,section_id,test_questions_options,math_type }) => ({
      question_id: id,
      question_option_id: this.props.resume_test && test_questions_options.some(op => op.selected_option) 
        ? test_questions_options.find(op => op.selected_option)?.id  : null,
      timetaken: [],
      screenshot: 0,
      isMarkedForReview: false,
      action_type: 0,
      // isBookMarked : is_bookmarked,
      question_section_id: section_id,
      question_section_marks: this.props.sections.find(sec => section_id === sec.id)?.marks,
      test_questions_options :test_questions_options,
      math_type,
    })),
    testSubmitting: false,
    // total_timetaken: 0,
    visitedTimeStamp: moment().format('YYYY-MM-DD HH:mm:ss').toString(),
    offline: false,
    testSubmittedFromMulitpleFraud: false,
    showShimmer: false,
    pageMounted: false,
    event: null,
    noOfWindowSwitches: 0,
    visible : true,
    dialogTitle: 'Are you sure you want to submit the test ?',
    instructionModalOpen: false
  };


  // This method is depricated
  // componentWillMount() {
  //   localStorage.removeItem('lastX');
  //   localStorage.removeItem('lastScrollLeftPosition');
  // }

  cancelSubscriptions(){
    document.removeEventListener('visibilitychange',this.hiddenFunction)
    document.removeEventListener('mozvisibilitychange',this.mozHiddenFunction)
    document.removeEventListener('webkitvisibilitychange',this.webkitHiddenFunction)
    document.removeEventListener('msvisibilitychange',this.msHiddenFunction)    
  }


  componentDidMount = async () => {

    // Making sure scroll states are removed.
    localStorage.removeItem('lastX');
    localStorage.removeItem('lastScrollLeftPosition');

    window.addEventListener("online", () => {
      this.setState({ offline: false });
    }, false);
    window.addEventListener("offline", () => {
      this.setState({ offline: true });
    }, false);
    document.body.style.background = 'white';
    this.askBeforeUserLeaving();
    var self = this;
    var el = document.getElementById('questionArea')
    swipedetect(el, function (swipedir) {
      if (swipedir == 'left' || swipedir == 'right') {
        self.onLeftorRightSwipe(swipedir);
      }
      if (swipedir == 'top' || swipedir == 'down') {
        console.log('up or down');
      }
    });

    // Checking if the test is new or resumed test
    // const {resume_test, questions} = this.props;
    const { tid, name,questions, timelimit, expiryTime, results, resume_test, remaining_test_duration } = this.props

    console.log(`resume_test : ${resume_test}`)
    console.log(questions)

    // If resuming the test, pre select answers and change the test duration time left.
    if(resume_test){
      this.setState(async prevState => {
        const question_answers = prevState.question_answers;

        questions.forEach((question,i)=>{
          // Will return an option id which is selected, if not undefined will be the output
          const selected_option_data = question.test_questions_options.find(op => op.selected_option ===1);
          const selected_option_id = selected_option_data !==undefined ? selected_option_data?.id : false;
          if (selected_option_id) {
            const question_index = question_answers.findIndex((ques) => ques.question_id === question.id)
            console.log(`question_index : ${question_index}`)
            prevState.question_answers[question_index].question_option_id = selected_option_id;
            // prevState.question_answers.question_option_id - need to change it for the question

          }
        })

        console.log(prevState)
        return prevState;
        }
      )
    }

    // Adding time stamp for first quesiton
    this.setState( prevState =>{
      let datetime = moment().format('YYYY-MM-DD HH:mm:ss').toString();
      prevState.visitedTimeStamp = datetime;
      return prevState;
    })  

    updateSeenStatus(this.props.tid);

    // Amplitude Tracking 
    const eventProperties = {
      test_id: tid,
      test_name : name,
      timelimit,
      expiryTime,
      results,
      resume_test,
      remaining_test_duration,
      // previois_screen_name: 'dashboard'
      }
      let eventName
      if (results) {
        eventName = 'test_results_opened'
      }
      else{
        eventName = 'test_started_successfully'
      }
      const result = await track(eventName,eventProperties).promise;
      if (result?.code ===200) {
        console.log(`Amplitude Event Fired Successfully. Event : ${eventName}`)
      }
      else {
        console.log(`Amplitude Event Not Fired. Event : ${eventName}`)
      }
      console.log(result)

  }
  onVisibilityChangeCallBack = (visible) =>{
    const { tid } = this.props
    if(!visible){
      // console.log('visibility changes')
      // console.log(this.state.noOfWindowSwitches)
      if (this.state.noOfWindowSwitches < 1) {
          // Amplitude Tracking
          const eventProperties = {
            test_id: tid,
            // previois_screen_name: 'dashboard'
            }
          track('test_tab_change_first',eventProperties);
        this.setState({noOfWindowSwitches : this.state.noOfWindowSwitches+1})
        console.log("Warning: You are NOT allowed to switch apps during the test! ");
        this.setState({windowChangeWarningModalOpen: true, dialogTitle: 'Warning: You are NOT allowed to switch apps during the test! '})
      } else {
          // Amplitude Tracking
          const eventProperties = {
            test_id: tid,
            // previois_screen_name: 'dashboard'
            }
          track('test_tab_change_twice',eventProperties);
        console.log("Warning: You are NOT allowed to switch apps during the test! ");
        this.setState({testSubmittedFromMulitpleFraud:true});
        this.handleSubmit(4);
        this.setState({testSubmittedModalOpen: true, dialogTitle: 'Your Test has been submitted!!',windowChangeWarningModalOpen: false})
      }
      // } 
    }
    console.log('the page is now', visible ? 'focused' : 'unfocused');
  }
  askBeforeUserLeaving(){
    try {
      this.onVisibilityChange(this.onVisibilityChangeCallBack);
    } catch (error) {
      console.log(error);
    }
    // window.addEventListener("beforeunload",(event)=> this.beforeUnloadFunction(event));
  }


  // askBeforeUserLeaving() {
  //   const { tid } = this.props
  //   // Remove comments after testing
  //   try {
  //     this.onVisibilityChange((visible) => {
  //       if (!visible) {
  //         if (this.state.noOfWindowSwitches < 1) {

  //           // Amplitude Tracking
  //           const eventProperties = {
  //             test_id: tid,
  //             // previois_screen_name: 'dashboard'
  //             }
  //           track('test_tab_change_first',eventProperties);


  //           this.setState({ noOfWindowSwitches: this.state.noOfWindowSwitches + 1 })
  //           console.log("Warning: You are NOT allowed to switch apps during the test! ");
  //           this.setState({ windowChangeWarningModalOpen: true, dialogTitle: 'Warning: You are NOT allowed to switch apps during the test! ' })
  //         } else {
  //             // Amplitude Tracking
  //             const eventProperties = {
  //               test_id: tid,
  //               // previois_screen_name: 'dashboard'
  //               }
  //             track('test_tab_change_twice',eventProperties);

  //           console.log("Warning: You are NOT allowed to switch apps during the test! ");
  //           this.setState({ testSubmittedFromMulitpleFraud: true });
  //           this.handleSubmit(4);
  //           this.setState({ testSubmittedModalOpen: true, dialogTitle: 'Your Test is auto submitted!!' })
  //         }
  //       }
  //       // console.log('the page is now', visible ? 'focused' : 'unfocused');
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }

  //   window.addEventListener("beforeunload", function (e) {
  //     var confirmationMessage = 'It looks like you have been editing something. '
  //       + 'If you leave before saving, your changes will be lost.';

  //     (e || window.event).returnValue = confirmationMessage; //Gecko + IE
  //     return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
  //   });
  // }

  // hiddenFunction (unfocused,focused) { (document.hidden ? unfocused : focused)() }
  // mozHiddenFunction (unfocused,focused) { (document.mozHidden ? unfocused : focused)() }
  // webkitHiddenFunction (unfocused,focused) { (document.webkitHidden ? unfocused : focused)() }
  // msHiddenFunction (unfocused,focused) { (document.msHidden ? unfocused : focused)() }


  focused = (callback) => {
    if (!this.state.visible) {
      this.setState({visible : true})
      callback( true);
    }
  }

  unfocused = (callback) => {
    if (this.state.visible) {
      this.setState({visible: false})
      callback( false);

    }
  }

  mozVisiblityChangeFunction = (callBack) => {
      (document.mozHidden ? this.unfocused : this.focused)(callBack)
  }
  visiblityChangeFunction = (callBack) => {
      (document.hidden ? this.unfocused : this.focused)(callBack)
  }
  webkitVisiblityChangeFunction = (callBack) => {
      (document.webkitHidden ? this.unfocused : this.focused)(callBack)
  }
  msVisiblityChangeFunction = (callBack) => {
      (document.msHidden ? this.unfocused : this.focused)(callBack)
  }
  onVisibilityChange(callback) {
    var visible = true;

    if (!callback) {
        throw new Error('no callback given');
    }

    // Standards:
    if ('hidden' in document) {
        document.addEventListener('visibilitychange',() => this.visiblityChangeFunction(callback));
    }
    if ('mozHidden' in document) {
        document.addEventListener('mozvisibilitychange',()=> this.mozVisiblityChangeFunction(callback));
    }
    if ('webkitHidden' in document) {
        document.addEventListener('webkitvisibilitychange',()=>this.webkitVisiblityChangeFunction(callback));
    }
    if ('msHidden' in document) {
        document.addEventListener('msvisibilitychange',()=>this.msVisiblityChangeFunction(callback));
    }
    // IE 9 and lower:
    if ('onfocusin' in document) {
        document.onfocusin = () =>this.focused(callback);
        document.onfocusout = () =>this.unfocused(callback);
    }
    // All others:
    window.onpageshow = window.onfocus = ()=>this.focused(callback);
    window.onpagehide = window.onblur = ()=>this.unfocused(callback);
  };
  // onVisibilityChange(callback) {
  //   var visible = true;

  //   if (!callback) {
  //     throw new Error('no callback given');
  //   }

  //   function focused() {
  //     if (!visible) {
  //       callback(visible = true);
  //     }
  //   }

  //   function unfocused() {
  //     if (visible) {
  //       callback(visible = false);
  //     }
  //   }
  //   document.addEventListener('visibilitychange',this.hiddenFunction);
  //   // Standards:
  //   // if ('hidden' in document) {
  //   //   document.addEventListener('visibilitychange',
  //   //     this.hiddenFunction);
  //   // }
  //   if ('mozHidden' in document) {
  //     document.addEventListener('mozvisibilitychange',this.mozHiddenFunction);
  //   }
  //   if ('webkitHidden' in document) {
  //     document.addEventListener('webkitvisibilitychange',this.webkitHiddenFunction);
  //   }
  //   if ('msHidden' in document) {
  //     document.addEventListener('msvisibilitychange',this.msHiddenFunction);
  //   }
  //   // IE 9 and lower:
  //   if ('onfocusin' in document) {
  //     document.onfocusin = focused;
  //     document.onfocusout = unfocused;
  //   }
  //   // All others:
  //   window.onpageshow = window.onfocus = focused;
  //   window.onpagehide = window.onblur = unfocused;
  // };

  // onVisibilityChange(callback) {
  //   var visible = true;

  //   if (!callback) {
  //     throw new Error('no callback given');
  //   }

  //   function focused() {
  //     if (!visible) {
  //       callback(visible = true);
  //     }
  //   }

  //   function unfocused() {
  //     if (visible) {
  //       callback(visible = false);
  //     }
  //   }

  //   // Standards:
  //   if ('hidden' in document) {
  //     document.addEventListener('visibilitychange',
  //       function () { (document.hidden ? unfocused : focused)() });
  //   }
  //   if ('mozHidden' in document) {
  //     document.addEventListener('mozvisibilitychange', function () {
  //       (document.mozHidden ? unfocused : focused)()
  //     });
  //   }
  //   if ('webkitHidden' in document) {
  //     document.addEventListener('webkitvisibilitychange',
  //       function () { (document.webkitHidden ? unfocused : focused)() });
  //   }
  //   if ('msHidden' in document) {
  //     document.addEventListener('msvisibilitychange',
  //       function () { (document.msHidden ? unfocused : focused)() });
  //   }
  //   // IE 9 and lower:
  //   if ('onfocusin' in document) {
  //     document.onfocusin = focused;
  //     document.onfocusout = unfocused;
  //   }
  //   // All others:
  //   window.onpageshow = window.onfocus = focused;
  //   window.onpagehide = window.onblur = unfocused;
  // };

  testSubmittedOnLeavingWindow = () => {
    let bool = this.checkNative();

    if (bool) {
      //Native app.
      this.callbackToNative("submit");
      localStorage.removeItem("lastX");
      localStorage.removeItem("lastScrollLeftPosition");

      // Adding a page push, so that test page is removed and completed page is show if callbacktToNative doesn't work.
      history.push(`/completed`);
    } else {
      localStorage.removeItem("lastX");
      localStorage.removeItem("lastScrollLeftPosition");

      history.push(`/completed`);
    }
  };

  onLeftorRightSwipe = (swipedir) => {
    let { qid, search, questions, tid } = this.props;
    let swipeDistance;
    if (swipedir === 'left' && qid == questions.length - 1) return;
    if (swipedir === 'right' && qid == 0) return;
    this.setState({ showShimmer: true })
    let newqid
    setTimeout(() => {
      this.setState({ showShimmer: false })
      if (swipedir === 'left') {
        newqid = parseInt(qid) + 1
        swipeDistance = window.innerWidth * 0.75;
        history.push(`/test/${tid}/${newqid}`);
        // history.push(`/test/${tid}/${parseInt(qid) + 1}`);
      } else {
        newqid = parseInt(qid) - 1
        swipeDistance = window.innerWidth / 4;
        history.push(`/test/${tid}/${newqid}`);
        // history.push(`/test/${tid}/${parseInt(qid) - 1}`);
      }
      this.onQuestionClick(parseInt(qid), newqid, null, swipeDistance,swipedir === 'left' ? 4 : 1);

    }, 100)
  }

  previousQuestion = async (id) => {
    let { qid, search, questions, tid } = this.props;
    if(id) qid = id;
    let swipeDistance;
    if (qid == 0) return;
    this.setState({ showShimmer: true })
    setTimeout(() => {
      this.setState({ showShimmer: false })
      
      swipeDistance = window.innerWidth / 4;
      history.push(`/test/${tid}/${parseInt(qid) - 1}`);
      this.onQuestionClick(parseInt(qid), parseInt(qid) -1, null, swipeDistance, 4);
      
    }, 100)
  }
  
  nextQuestion = async (id) => {
    let { qid, search, questions, tid } = this.props;
    if(id) qid = id;
    let swipeDistance;
    if (qid == questions.length - 1) return;
    this.setState({ showShimmer: true })
    setTimeout(() => {
      this.setState({ showShimmer: false })
      swipeDistance = window.innerWidth * 0.75;
      history.push(`/test/${tid}/${parseInt(qid) + 1}`);

      this.onQuestionClick(parseInt(qid), parseInt(qid) +1, null, swipeDistance, 1);

    }, 100)
  }

  updateScrollStates(event, pageX) {
    try {
      pageX = event && event.pageX || pageX;
      if (!event && !pageX) return;
      let width = window.innerWidth;
      let center = width / 2;
      let difference = pageX - center;
      let scrollbleElement = document.getElementById('mobile-scroller');
      scrollbleElement.scrollBy({
        left: difference,
        behavior: 'smooth'
      });
      localStorage.setItem('lastX', pageX);
      localStorage.setItem('lastScrollLeftPosition', scrollbleElement.scrollLeft);
    } catch (error) {
      alert(error);
    }
  }

  onQuestionClick = async (qid, i, event, pageX, type) => {
    try {
      if (event && qid !== i) {
        this.setState({ showShimmer: true })
        setTimeout(() => {
          this.setState({ showShimmer: false })
        }, 125)
      }
      this.updateScrollStates(event, pageX);

      let { tid, questions } = this.props;
      console.log('submitQuestion')
  
      let datetime = moment().format('YYYY-MM-DD HH:mm:ss');
  

      this.setState(async prevState => {
        // Finding the questions and adding the data that needs to be sent.
        // console.log(prevState.question_answers)
        let questionAllData = prevState.question_answers.find(
          ({ question_id }) => question_id === questions[qid].id
        );

        let newQuestionAllData = prevState.question_answers.find(
          ({ question_id }) => question_id === questions[i].id
        );
        // console.log(questionAllData)
    
        // Extracting Data required from the question
        const {
          action_type,
          isMarkedForReview,
          question_id,
          question_option_id,
          question_section_id,
          question_section_marks,
          screenshot,
        } = questionAllData;
    
    
        const question = {
          action_type,
          isMarkedForReview,
          question_id,
          question_option_id,
          question_section_id,
          question_section_marks,
          screenshot,
        };
    
        // Adding duration of time spent by student on question to api
        const firstVisitTimeStamp = moment(prevState.visitedTimeStamp)
        const questionVisitDuration = moment(datetime).diff(firstVisitTimeStamp, "seconds");

        // console.log(questionVisitDuration);
        let timetaken = [prevState.visitedTimeStamp, datetime.toString(), questionVisitDuration];
    
        question.timetaken = timetaken;
        question.action_type = type;
        question.started_time = prevState.visitedTimeStamp;
        question.internet_speed=this.props.networkSpeed;

        // Modifying / Adding All the Data to State
        
        questionAllData.timetaken = timetaken;
        questionAllData.action_type = type;
        questionAllData.started_time = prevState.visitedTimeStamp;
    
        console.log(question); 


        const res = await submitMCQQuestion({questionData : question,tid});


        const eventProperties = {
          question_id: question?.question_id,
          action_type: question?.action_type,
          question_option_id: question?.question_option_id,
          timetaken : question.timetaken,
          next_question_id: newQuestionAllData?.question_id,
          test_id: tid,
        }

        let eventName;
        if(res?.data?.status === 200){
          // track('question_submitted',eventProperties);
          eventName = "question_submitted"
        }
        else{
          // track('question_not_submitted',eventProperties);
          eventName = "question_not_submitted"
        }

        const trackingResult = await track(eventName,eventProperties).promise;
        if (trackingResult?.code ===200) {
          console.log(`Amplitude Event Fired Successfully. Event : ${eventName}`)
        }
        else {
          console.log(`Amplitude Event Not Fired. Event : ${eventName}`)
        }
        console.log(trackingResult)

        // console.log(res)
        // if(!res) this.handleSubmit(2);
        return prevState;
      });
      this.setState(prevState => {
        prevState.visitedTimeStamp = datetime;
        return prevState;
      });
    } catch (error) {
      console.log(error);
    }
  }


  stripHtml = (html,type=0) => {
    // if(type===0){
      let div = document.createElement("DIV");
      div.innerHTML = html;
      const strippedText =  div.textContent || div.innerText || "";
      // console.log(strippedText);
      return strippedText.replace('$','').slice(0,7) + '...';
    // }
    // else{
    //   return html
    // }
  }
  

  checkNative = () => {
    try {
      if ((window.webkit) || window.appInterface){
        console.log(window.webkit)
        console.log(window.appInterface)
          return true;
      }
      else return false;
    } catch (error) {
      console.log(error);
    }
  }

  callbackToNative = (msg) => {
    try {
      // console.log('calling back native' + msg)
      if (window.webkit != undefined) {
        window.webkit.messageHandlers.observe.postMessage(msg);
        window.webkit.messageHandlers.appInterface.postMessage(msg)
      }
      if (window.appInterface != undefined) {
        window.appInterface.postMessage(msg)
      }
    } catch (error) {
      console.log(msg);
      console.log(error);
    }
  }


  // handleSubmit = async (type) => {
  //   if (this.state.offline) {
  //     this.callbackToNative("done");
  //     this.setState({ modalOpen: false });
  //     return;
  //   }
  //   if (this.state.testSubmitting) return;
  //   this.setState({ testSubmitting: true });
  //   let { submitTest, tid, qid } = this.props;
  //   console.log('onQuestionClick')
  //   await this.onQuestionClick(qid, null, null, null ,2);
  //   console.log('submitTest')
  //   let success = await submitTest({ ...this.state },type);
  //   // console.log(success)
  //   this.setState({ testSubmitting: false });
  //   if (success) {
  //     if (this.state.testSubmittedFromMulitpleFraud) {
  //       return;
  //     }
  //     let bool = this.checkNative();
  //     if (bool) {
  //       //Native app.
  //       this.callbackToNative("submit");
  //       localStorage.removeItem('lastX');
  //       localStorage.removeItem('lastScrollLeftPosition');
  //     } else {
  //       localStorage.removeItem('lastX');
  //       localStorage.removeItem('lastScrollLeftPosition');

  //       // history.push(`/testOverview/${tid}`);
  //       history.push(`/completed`);

  //       // history.push(`/testResults/${tid}`);
  //     }
  //   } 
  //   // else {
  //   //   alert("Something goes wrong, please submit again!");
  //   // }
  // };


  handleSubmit = async (type) => {
    if (this.state.offline) {
      this.callbackToNative("done");
      this.setState({ modalOpen: false });
      return;
    }
    if (this.state.testSubmitting) return;
    this.setState({ testSubmitting: true });

    let { submitTest, tid, qid,questions } = this.props;
    console.log('submitTest')

    let datetime = moment().format('YYYY-MM-DD HH:mm:ss');

    // Finding the questions and adding the data that needs to be sent.
    let questionAllData = this.state.question_answers.find(
      ({ question_id }) => question_id === questions[qid].id
    );
    // console.log(questionAllData)

    // Extracting Data required from the question
    const {
      action_type,
      isMarkedForReview,
      question_id,
      question_option_id,
      question_section_id,
      question_section_marks,
      screenshot,
    } = questionAllData;


    const question = {
      action_type,
      isMarkedForReview,
      question_id,
      question_option_id,
      question_section_id,
      question_section_marks,
      screenshot,
    };


    // Adding duration of time spent by student on question to api
    const firstVisitTimeStamp = moment(this.state.visitedTimeStamp)
    const questionVisitDuration = moment(datetime).diff(firstVisitTimeStamp, "seconds");

    // const questionVisitDuration = moment().diff(this.state.visitedTimeStamp, "seconds");

    let timetaken = [this.state.visitedTimeStamp, datetime.toString(), questionVisitDuration];


    question.timetaken = timetaken;
    question.action_type = type;
    question.started_time = this.state.visitedTimeStamp;
    question.internet_speed=this.props.networkSpeed;

    // console.log(question);


    let success = await submitTest({questionData : question,tid},type);
    // console.log(success)
    this.setState({ testSubmitting: false });
    if (success) {
      this.cancelSubscriptions();
      // Setting the data on the question visited time duration for best practise. 
      this.setState(prevState => {
        prevState.visitedTimeStamp = datetime;
        return prevState;
      });

      const eventProperties = {
        question_id: question?.question_id,
        action_type: question?.action_type,
        question_option_id: question?.question_option_id,
        timetaken : question.timetaken,
        test_id: tid,      
      }

      //Need to add auto submission message
      if (this.state.testSubmittedFromMulitpleFraud) {
        // Amplitude Tracking
        track('test_submitted_for_multiple_tab_switches',eventProperties);
        return;
      }
      
      track('test_submitted',eventProperties);

      let bool = this.checkNative();
      if (bool) {
        //Native app.
        this.callbackToNative("submit");
        localStorage.removeItem('lastX');
        localStorage.removeItem('lastScrollLeftPosition');

        // Adding a page push, so that test page is removed and completed page is show if callbacktToNative doesn't work.
        history.push(`/completed`);
      }
      else {
        localStorage.removeItem('lastX');
        localStorage.removeItem('lastScrollLeftPosition');

        // history.push(`/testOverview/${tid}`);
        history.push(`/completed`);

        // history.push(`/testResults/${tid}`);
      }
    } 
    // else {
    //   alert("Did not submit, please submit again!");
    // }
  };

  windowChangeWarningModalClose = () => {
    if (!this.state.offline)
      this.setState({ windowChangeWarningModalOpen: false, dialogTitle: 'Are you sure you want to submit the test ?' });
  }
  handleModalToggle = () => {
    if (this.state.offline) {
      this.setState({
        dialogTitle: 'Your not connected to active internet.',
        modalOpen: true
      });
      return;
    } else {
      const eventProperties = {
        test_id: this.props.tid,
        }
      if(this.state.modalOpen){
        // Amplitude Tracking
        track('submition_cancelled',eventProperties);
      }
      else if (!this.state.modalOpen) {
        // Amplitude Tracking
        track('submition_attempted',eventProperties);
      }
      this.setState({ modalOpen: !this.state.modalOpen, dialogTitle: 'Are you sure you want to submit the test ?' });
    }
  };

  handleMarkforReview = () => {
    let { tid, qid, questions } = this.props;
    this.setState(prevState => {
      let question = prevState.question_answers.find(
        ({ question_id }) => question_id === questions[qid].id
      );
      // question.question_option_id = null;
      question.isMarkedForReview = !question.isMarkedForReview;

      // Amplitude Tracking
      const eventProperties = {
        test_id : tid,
        question_id : question.question_id,
        is_marked_for_review : question.isMarkedForReview,
      }
      track('question_marked_status',eventProperties);
      return prevState;
    });
  };

  // updateTimers = () => {
  //   this.setState(prevState => {
  //     let datetime = moment().format('YYYY-MM-DD hh:mm:ss').toString();
  //     if (!prevState.visitedTimeStamp) {
  //       prevState.visitedTimeStamp = datetime
  //     };
  //     prevState.total_timetaken = prevState.total_timetaken + 1;
  //     prevState.questionVisitDuration = prevState.questionVisitDuration + 1
  //     return prevState;
  //   });
  // }

  handleCheck = (id) => {
    let { tid, qid, questions } = this.props;
    // console.log(`id : ${id}`)
    this.setState(prevState => {
      let question = prevState.question_answers.find(
        ({ question_id }) => question_id === questions[qid].id
      );
      question.question_option_id = id;

      // Amplitude Tracking
      if(question.isMarkedForReview){
        const eventProperties = {
          test_id : tid,
          question_id : question.question_id,
          is_marked_for_review : false,
        }
        track('question_marked_status',eventProperties);
      }
      question.isMarkedForReview = false;

      // question.is_answer = is_answer;
      return prevState;
    });
  };

  // addOrDeleteBookmark = async () => {
  //   console.log('addOrDeleteBookmark');
  //   console.log(`this.props.qid : ${this.props.qid}`)

  //   const question_answers = this.state.question_answers;

  //   let qid = this.props.questions[this.props.qid].id;
  //   console.log(`qid : ${qid}`)

  //   const question_index = question_answers.findIndex((ques) => ques.question_id === qid);
  //   let is_bookmarked = question_answers[question_index].isBookMarked;

  //   // let is_bookmarked = this.props.questions[this.props.qid].is_bookmarked;
  //   if (is_bookmarked === 0) {
  //     let response = await addQuestionBookmark(qid);
  //     if (response.status === 200) {
  //       // this.props.questions[this.props.qid].is_bookmarked = 1
  //       this.setState((prevState) => {
  //         return prevState.question_answers[question_index].isBookMarked = 1;
  //       });
  //     }
  //   } else if (is_bookmarked === 1) {
  //     let response = await deleteQuestionBookmark(qid);
  //     if (response.status === 200) {
  //       // this.props.questions[this.props.qid].is_bookmarked = 0
  //       this.setState((prevState) => {
  //         return prevState.question_answers[question_index].isBookMarked = 0;
  //       });
  //     }
  //   }
  // };


  openInstructionPage = () => {
    this.setState({ instructionModalOpen: true })
  }

  closeInstruction = () => {
    // console.log('closing')
    this.setState({ instructionModalOpen: false })
  }
  render() {
    let { tid, qid, questions, sections, timelimit,resume_test,remaining_test_duration, expiryTime, name, description } = this.props;
    // console.log(this.props);
    let { question_answers, modalOpen, testSubmittedModalOpen, windowChangeWarningModalOpen, instructionModalOpen } = this.state;
    if (!questions || !questions.length) {
      return <p>No questions</p>;
    }
    if (this.state.testSubmitting) {
      return <p>Test is Submitting, Please wait</p>;
    }

    // Handling Time Limit
    let testDurationLeft  
    if(resume_test){
      testDurationLeft = expiryTime < remaining_test_duration ? expiryTime : remaining_test_duration;
    }
    else{
      testDurationLeft = expiryTime < timelimit ? expiryTime : timelimit;
    }

    // let pattern = /\$.*?\$/gm;
    let progress = ((+(qid) + 1) / questions.length) * 100;
    let greyWidth = 100 - progress;
    let sections_dict = {};
    sections.map((sec, index) => {
      sections_dict[sec.id] = sec;
      if (index % 2 == 0) {
        sections_dict[sec.id]['color'] = '#eee'
      } else {
        sections_dict[sec.id]['color'] = '#fff'
      }
    })
    // console.log(this.props);
    // console.log("offline - " + this.state.offline);
    return (
      <div style={{ backgroundColor: 'white' }}>
        <div style={{ position: 'fixed', top: '0', left: '0', backgroundColor: 'white', width: '100%', zIndex: '1', height: '100px' }}>
          <div style={{ backgroundColor: 'white', overflow: 'hidden' }}>
            <div style={{ textAlign: 'right', marginTop: '1.5em', marginRight: '2em' }}>
              <img onClick={this.openInstructionPage} src='/images/info_icon.png'></img>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ margin: 'auto', marginTop: '15px', marginLeft: '1.3em', fontSize: '18px', fontWeight: '600', display: 'flex', flexDirection: 'row', textAlign: 'left' }}>
                <img style={{ width: '12px' }} src="/images/hourglass.svg"></img>&nbsp;<span>
                  <ProgressBar updateTimers={this.updateTimers} timelimit={testDurationLeft} handleTimeout={() => this.handleSubmit(1)} />
                </span>
              </div>
              <div style={{ margin: 'auto', marginRight: '1.5em' }}>
                <div className='submitButton' onClick={this.handleModalToggle}>Submit Test</div>
              </div>
            </div>
            <div style={{width: '100%', textAlign: 'right', padding: '10px'}}>
                Network Speed :{" "}
                <span
                  style={{
                    color:
                      this.props.networkSpeed > 0 && this.props.networkSpeed <= 1
                        ? "red"
                        : this.props.networkSpeed > 1 &&
                          this.props.networkSpeed <= 3
                        ? "gold"
                        : this.props.networkSpeed > 3 &&
                          this.props.networkSpeed <= 5
                        ? "GoldenRod"
                        : this.props.networkSpeed > 5 &&
                          this.props.networkSpeed <= 10
                        ? "green"
                        : this.props.networkSpeed > 10
                        ? "green"
                        : "grey",
                  }}
                >
                  {this.props.networkSpeed > 0 && this.props.networkSpeed <= 1
                    ? "Critically Low"
                    : this.props.networkSpeed > 1 && this.props.networkSpeed <= 3
                    ? "Low"
                    : this.props.networkSpeed > 3 && this.props.networkSpeed <= 5
                    ? "Stable"
                    : this.props.networkSpeed > 5 && this.props.networkSpeed <= 10
                    ? "High"
                    : this.props.networkSpeed > 10
                    ? "Very High"
                    : "Retrieving"}
                </span>
              </div>
            <Flex style={{margin: '10px 0'}}>
              <div style={{ margin: '1em 1.5em 0 1.5em', fontSize: '16px', fontWeight: '600' }}>
                {+(qid) + 1} of {questions.length}
              </div>
              <div style={{ margin: '1em 1.5em 0 auto ', width: '30px', marginRight: '1.5em', justifyContent: 'flex-end', display: 'flex', flexDirection: 'row' }}>
                {qid != 0 ?
                  <img style={{ marginRight: '20px' }} onClick={() => this.previousQuestion(qid)} src="/images/backArrow.svg" alt="back"/>
                  : null}
                {qid + 1 != questions.length ?
                  <img onClick={() => this.nextQuestion(qid)} src="/images/frontArrow.svg" alt="next" />
                  : null}
              </div>

            </Flex>
            <div style={{ margin: '1em 1.5em' }}>
              <div style={{ width: '100%', height: '6px', display: 'flex', flexDirection: 'row' }}>
                <div className='gradient' style={{ width: progress + '%' }}></div>
                <div className='greyProgress' style={{ width: greyWidth + '%', backgroundColor: '#eee' }} ></div>

              </div>

            </div>
          </div>
        </div>
        <MCQLayoutWrapper large={true} style={{ marginTop: '200px' }} id='questionArea'>
          {this.state.showShimmer ? <Shimmer /> :
            <GridLayout>
              <Flex column>
                <Box><TestEquation section_name={questions[qid].section_id ? sections_dict[questions[qid].section_id].name : null} math_type={questions[qid].math_type} bold equation={questions[qid].name}></TestEquation></Box>
                {questions[qid].media === 1 && (
                  <Image center>
                    <img src={questions[qid].question_img} alt="" />
                  </Image>
                )}
                <Hint alignCenter>
                  <div style={{ cursor: "pointer" }} onClick={this.handleMarkforReview}>
                    <span>{question_answers[qid].isMarkedForReview ? 'Marked For Review' : 'Mark For Review'}</span>
                  </div>
                  <div style={{ margin: 'auto', marginRight: '5px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <div style={{ cursor: "pointer", marginRight: '0px' }}>
                      <Report testId={tid} questionId={questions[qid].id} ></Report>
                    </div>
                  </div>
                </Hint>

                {/* <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                  {questions[qid].test_questions_options.map(
                    ({ id, name, media, option_img, is_answer }, i) => (
                      <div key={i} onClick={() => this.handleCheck(id, is_answer)} className={question_answers[qid].question_option_id === id ? 'gradient2' : 'gradient1'}>
                        <div className="qNo"><p style={{ margin: '0.2em 0' }}>{i + 1}</p></div>
                        <div style={{ paddingLeft: '30px', paddingRight: '20px' }}>
                          <Equation answered={question_answers[qid].question_option_id === id} math_type={questions[qid].math_type} equation={name}></Equation>
                          {media === 1 && <img src={option_img} alt="" />}
                        </div>
                      </div>
                    )
                  )}
                </div> */}

                <MCQuestion handleCheck={this.handleCheck.bind(this)} qid={qid} question_answers={question_answers}/>

                {/* {qid == questions.length - 1 &&
                  <Flex justifyEnd>
                    <Button disabled={this.state.testSubmitting} onClick={this.handleModalToggle}>Submit</Button>
                  </Flex>
                } */}

                <ActionButtons>
                  <Flex justifyBetween>
                    {qid > 0 ? (
                      // <Link to={`/test/${tid}/${parseFloat(qid) - 1}`}>
                        <Button onClick={() => this.previousQuestion(qid)}>Previous</Button>
                      // </Link>
                    ) : (
                      <div />
                    )}
                    {questions.length - 1 > qid ? (
                      // <Link to={`/test/${tid}/${parseFloat(qid) + 1}`}>
                        <Button onClick={() => this.nextQuestion(qid)}>Next</Button>
                      // </Link>
                    ) : (
                      <div />
                    )}
                  </Flex>
                </ActionButtons>

              </Flex>

              <QuestionOverviewWrapper>
                <Flex column>
                  <Box simple>
                    <h3>Questions overview</h3>
                    <QuestionsOverview>
                      {questions.map(({ id }, i) => (
                        <Hexagon
                          key={id}
                          center
                          active={!(i - qid)}
                          blue={Boolean(question_answers[i].question_option_id)}
                          yellow={Boolean(question_answers[i].isMarkedForReview)}
                          onClick={() => this.onQuestionClick(qid, i, null, null, 3)}
                        >
                          <Link to={`/test/${tid}/${i}`}>
                            <Hex />
                            <span>{i + 1}</span>
                          </Link>
                        </Hexagon>
                      ))}
                    </QuestionsOverview>
                    <Flex center style={{ marginTop: "2em" }}>
                      <Button onClick={this.handleModalToggle}>Submit</Button>
                    </Flex>
                    <div style={{ marginTop: "2em" }}>
                      {[
                        { title: "Active Question", active: true },
                        { title: "Answered", color: "blue" },
                        { title: "Bookmarked", color: "yellow" },
                        { title: "Unanswered", color: "" }
                      ].map(({ active, color, title }) => (
                        <div key={title}>
                          <Flex alignCenter>
                            <Hexagon
                              active={active}
                              yellow={color == "yellow" ? true : false}
                              blue={color == "blue" ? true : false}
                            >
                              <a>
                                <Hex />
                              </a>
                            </Hexagon>
                            <p style={{ marginLeft: "1em" }}>{title}</p>
                          </Flex>
                        </div>
                      ))}
                    </div>
                  </Box>
                </Flex>
              </QuestionOverviewWrapper>

            </GridLayout>}



          <Modal
            open={modalOpen}
            handleModalToggle={this.handleModalToggle}
            handleSubmit={() => this.handleSubmit(3)}
            image={this.state.dialogTitle === "Are you sure you want to submit the test ?"
              ? "/images/gif/test_submit_confirm.gif"
              : "/images/gif/tick.gif"}
            dialogTitle={this.state.dialogTitle}
          />
          <div className="modal" style={{ display: this.state.reattempt_msg ? 'block' : 'none' }} >
            <div className="modal-content">
              <div>
                <p className="text-danger" style={{fontSize: 'large', fontWeight: 'bold', textAlign: 'center'}}>MUST READ</p>
                <p className="text-left">1. The test once opened either on your mobile or web application, will need <b>to be continued on the same device</b>, else you will be aborted from the test.</p>
                <p className="text-left">2. Once the test is started, you will <b>NOT</b> be allowed to change the device, attempt the test from other device or reattempt from same device.</p>
                <div onClick={() => this.startTest()} style={{ color: "#6568d9", textAlign: 'center', fontWeight: 'bold' }}>
                  I Confirm
                </div>
              </div>
            </div>
          </div>
          {/* <Modal1
            open={testSubmittedModalOpen}
            buttonText="OK"
            callBack={this.testSubmittedOnLeavingWindow}
            dialogTitle={this.state.dialogTitle}
          /> */}

          {/* Modal to show when there is no network i.e device is offline */}
          <Modal1
            open={this.state.offline}
            buttonText="Understood"
            image="/images/gif/no_network.gif"
            dialogTitle="Network Disconnected!"
          />

          {/* Modal to show when there is a warning or submissions happening */}
          <Modal1
            open={windowChangeWarningModalOpen || testSubmittedModalOpen}
            buttonText="I Understand"
            // image={this.state.dialogTitle === 'Your Test has been submitted!!'
            image={
              testSubmittedModalOpen
                ? "/images/gif/tick.gif"
                : windowChangeWarningModalOpen
                ? "/images/gif/tab_switch.gif"
                : null
            }
            callBack={testSubmittedModalOpen ? this.testSubmittedOnLeavingWindow : this.windowChangeWarningModalClose}
            dialogTitle={this.state.dialogTitle}
          />

          {/* <Modal1
            open={windowChangeWarningModalOpen}
            buttonText="I Understand"
            image={this.state.dialogTitle === "Your Test has been submitted!!" 
              ? "/images/gif/tick.gif" 
              : this.state.dialogTitle === "Warning: You are NOT allowed to switch apps during the test! " 
              ? "/images/gif/tab_switch.gif" 
              : "/images/gif/no_network.gif"}
              callBack={this.windowChangeWarningModalClose}
            dialogTitle={this.state.dialogTitle}
          /> */}


          <InstructionModal
            open={instructionModalOpen}
            callBack={this.closeInstruction}
            name={name}
            description={description}
            timelimit={timelimit}
            expiryTime={expiryTime}
            sections={sections}
          />
        </MCQLayoutWrapper>
        <MobileCarousel activeQId={qid}>

          {questions.map(({ id, name, math_type, section_id }, i) => (
            //Handle mobile click
            <Link to={`/test/${tid}/${i}`} key={i}>
              <div className={i == qid ? 'mqCardActive' : section_id && sections_dict[section_id].color == '#eee' ? 'mqCardGrey' : 'mqCard'} onClick={(event) => this.onQuestionClick(qid, i, event, null, 3)}>
                <Hexagon2
                  blue={Boolean(question_answers[i].question_option_id)}

                  yellow={Boolean(question_answers[i].isMarkedForReview)}
                  white={section_id && sections_dict[section_id].color == '#eee' ? true : false}
                  qNo={i + 1}></Hexagon2>
                <span>
                  <Equation answered={i == qid} math_type={math_type} equation={this.stripHtml(name,math_type)}></Equation>

                  {/* <Equation answered={i == qid} math_type={math_type} equation={name.slice(1, 4) === 'pre' ? name.slice(5, 13) + '...' : name.slice(0, 8) + '...'}></Equation> */}
                </span>
              </div>
            </Link>
          ))}
        </MobileCarousel>
        <style jsx='true' scoped>{`
          .mqCard{
            display: inline-block;
            width: 80px;
            margin: 5px;
            height: 60px;
            border: solid 1px #9E9E9E;
            border-radius: 5px;
            background: white;
            color:gray;
            transform:unset;
            box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
            span{
                position: relative;
                left: 5px;
                font-size: 11px;
                color:gray;
                pre{
                    margin:0px;
                }
            }
          }
          .mqCardGrey{
            display: inline-block;
            width: 80px;
            margin: 5px;
            height: 60px;
            border: solid 1px #fff;
            border-radius: 5px;
            background: #9E9E9E;
            color:gray;
            transform:unset;
            box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
            span{
                position: relative;
                left: 5px;
                font-size: 11px;
                color:gray;
                pre{
                    margin:0px;
                }
            }
          }
          .mqCardActive{
            display: inline-block;
            width: 80px;
            margin: 5px;
            height: 60px;
            border: solid 1px #9E9E9E;
            border-radius: 5px;
            background:
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
            color:white;
            transform:scale(1.1);
            box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
            span{
                position: relative;
                left: 5px;
                font-size: 11px;
                color:white;
                pre{
                    margin:0px;
                }
            }
          }
          .submitButton{
            background:
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
              margin: auto;
              float: right;
              margin-top: 12px;
              padding: 0.2em 1em;
              border-radius: 16px; 
              font-size: 16px;
              font-weight: 600;
              color: white;
              border: none;
              cursor: pointer;
              &:focus{
                outline:0;
              }
              @media (max-width: 768px) {
                display: block;
            }
          }
          .qNo{
            position: absolute;
            left: 5px;
            top: 6px;
            width: 20px;
            height: 20px;
            border-radius: 10px;
            text-align: center;
            background: #EEEEEE;
            font-size: 10px;
          }
          .gradient1{
            background: 
              linear-gradient(#fff,#fff) padding-box, 
              linear-gradient(to right bottom, #FFFFFF 0%, #4E54C8 39.777%, #DD92D8 100%) border-box;
            color: #313149;
            padding:10px;
            border: 2px solid transparent;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }

          .gradient2{
            background: 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
            color: #313149;
            padding:10px;
            border: 2px solid transparent;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }
          .gradient{
            background:linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box;
            border: 1px transparent;
            display: inline-block;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;


          }
          .greyProgress{
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
          }
        
        
        `}
        </style>

      </div>
    );
  }
}

export default TestStart;
